import type {FormBuilderRegistry} from 'src/app/form-builder/registry';
import {BasicFieldSettings} from 'src/app/form-builder/components/FieldSettings/components/BasicFieldSettings';
import {DropdownSettings} from 'src/app/form-builder/components/FieldSettings/components/DropdownSettings';
import {MeasurementSettings} from 'src/app/form-builder/components/FieldSettings/components/MeasurementSettings';
import {YesNoSettings} from 'src/app/form-builder/components/FieldSettings/components/YesNoSettings';
import {createDevicePreviewHeader} from './DevicePreviewHeader';
import {FieldEditorFieldTypeOptions} from './fieldEditorDefaults';
import {ResultPreviewLeadIn} from './ResultPreviewLeadIn';

/**
 * Builds the `FormBuilderRegistry` for InSpec's equipment-type field editor:
 * the server-side allow-list palette (`FieldEditorFieldTypeOptions`), the
 * lightweight `BasicFieldSettings` general panel (no `SectionValidation`/
 * notification-rule coupling `GeneralSettings` requires), the shared
 * `DropdownSettings`/`MeasurementSettings`/`YesNoSettings` panels
 * (each self-filters on field type, so having all mounted for every field
 * is harmless — InSpec does not use `ComplianceSettings`/`FailureSettings`),
 * no Form Settings accordion (equipment types have no form-level settings, so
 * the static "Form Description" identifier field is also suppressed in the
 * preview),
 * and the InSpec-specific preview chrome — device-card header (seeded with
 * the equipment-type name) and RESULT lead-in.
 */
export const createInspectionsFieldRegistry = (
  equipmentTypeName?: string
): FormBuilderRegistry => ({
  fieldTypes: FieldEditorFieldTypeOptions,
  settingsPanels: [
    BasicFieldSettings,
    DropdownSettings,
    MeasurementSettings,
    YesNoSettings,
  ],
  showFormSettings: false,
  showIdentifierFieldInPreview: false,
  previewHeader: createDevicePreviewHeader(equipmentTypeName),
  previewLeadIn: ResultPreviewLeadIn,
});
